export default "__VITE_ASSET__BRJyDN_C__";